import RootState from 'typings/RootState'
import { createSelector } from 'reselect'
import { Event } from '../../types/event'

export const selectEvent = (state: RootState): Event =>
  state.adminUpdateActivityProgress.event
